import { render, staticRenderFns } from "./remote-register.page.vue?vue&type=template&id=217c9a72&scoped=true&"
import script from "./remote-register.page.vue?vue&type=script&lang=js&"
export * from "./remote-register.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c9a72",
  null
  
)

export default component.exports